<mat-label
  class="font-size-headline color-city-blue"
  [ngStyle]="captionStyles()"
  id="{{ question.Id }}"
>
  {{ question.Caption | qnaTranslate }}
</mat-label>
@for (option of options; track option; let i = $index) {
<div>
  <div fxLayout="row">
    <div fxLayout="column" style="padding-right: 0.5em">
      <mat-checkbox
        value="{{ option }}"
        (change)="setAnswer($event)"
        checked="{{ indexSelected[i] }}"
        id="questionOption{{ question.Id }}{{ i }}"
      >
        <div
          fxLayout="row"
          [ngStyle]="questionDetailsStyles()"
          style="align-items: center"
        >
          <span class="checkbox-textwrap color-dark-blue font-size-body-text">
            {{ translatedOption[i] }}
            @if (question.IsRequired) {
            <mat-label class="color-city-red"> *</mat-label>
            }
          </span>
        </div>
      </mat-checkbox>
    </div>
  </div>
  @if (expendChilds(option)) {
  <div fxLayout="row">
    <div fxFlex="100" fxLayout="column">
      @for (nextQuestion of getRuleDetails(option); track nextQuestion) {
      <div class="rules-render">
        @if (nextQuestion) {
        <div>
          <app-permit-question-render
            [question]="nextQuestion"
            [hasContentError]="nextQuestion.HasContentError"
          ></app-permit-question-render>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
</div>
} @if (question.IsRequired && !question.Answer && (answerTouched ||
question.HasContentError)) {
<mat-error>
  {{ isRequiredMessageDisplay }}
</mat-error>
}
